import { LoaderContainer } from './Loader.styled';
export const Loader = () => {
  return <LoaderContainer>Loading...</LoaderContainer>;
};
